let env;
if (process.env.NODE_ENV === "production") {
   env = require("../production-env");
} else {
    env = require('../production-env');
}

export function getEnvValue(key) {
    return env[key]
}



// WEBPACK FOOTER //
// ./src/controller/Environment.jsx